var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success"},[_vm._m(0),_c('div',{staticClass:"successText"},[_vm._v(" 恭喜你，注册成功 ")]),_c('div',{staticClass:"successTime"},[_c('span',[_vm._v(_vm._s(_vm.time)+"秒")]),_vm._v(" 后跳转至 "),_c('span',{staticClass:"span1",on:{"click":_vm.gotoLogin}},[_vm._v("登录页面")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("@/assets/image/icon-cg.png"),"alt":""}})])
}]

export { render, staticRenderFns }